import StripeInfo from './StripeInfo';

export default StripeInfo;
